import {
  FETCH_CLAIMS_REQUEST,
  FETCH_CLAIMS_SUCCESS,
  FETCH_CLAIMS_FAILURE,
  REVIEW_CLAIM_REQUEST,
  REVIEW_CLAIM_SUCCESS,
  REVIEW_CLAIM_FAILURE,
} from "../actions/types";

const initialState = {
  claims: [],
  pagination: {
    total: 0,
    page: 1,
    size: 10,
    pages: 1,
  },
  loading: false,
  error: null,
  message: "",
};

const claimReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CLAIMS_REQUEST:
    case REVIEW_CLAIM_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_CLAIMS_SUCCESS: {
      const payload = action.payload || {};

      return {
        ...state,
        loading: false,
        claims: payload.data || [],
        pagination: {
          total: payload.total ?? 0,
          page: payload.page ?? 1,
          size: payload.size ?? 10,
          pages: payload.pages ?? 1,
        },
        message: "Claims loaded successfully",
      };
    }

    case FETCH_CLAIMS_FAILURE:
      return { ...state, loading: false, error: action.payload, claims: [] };

    case REVIEW_CLAIM_SUCCESS: {
      const updated = action.payload;

      
      return {
        ...state,
        loading: false,
        claims: state.claims.map((c) =>
          c.claim_id === updated?.claim_id ? { ...c, ...updated } : c
        ),
        message: "Claim reviewed successfully",
      };
    }

    case REVIEW_CLAIM_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default claimReducer;